import { ErrorOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

interface ErrorViewProps {
  error: string | null;
  shippingNumber: number | null;
  onClose: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = ({ error, shippingNumber }) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 10 }}>
        <ErrorOutline sx={{ fontSize: 32, color: 'white', opacity: 0.9 }} />
        <Typography
          variant='h5'
          sx={{
            fontWeight: 700,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: 'white',
          }}
        >
          Error al procesar el arribo
        </Typography>
      </Box>

      <Box sx={{ textAlign: 'center', width: '100%', mb: shippingNumber ? 6 : 0 }}>
        <Typography
          variant='h1'
          sx={{
            fontWeight: 800,
            fontSize: {
              xs: '2.2rem',
              md: error && error.length > 25 ? '3rem' : '4.5rem'
            },
            lineHeight: 1.1,
            textTransform: 'uppercase',
            letterSpacing: '-1px',
            color: 'white',
            fontFamily: 'Karla, sans-serif',
            maxWidth: '900px',
            mx: 'auto',
            wordBreak: 'break-word'
          }}
        >
          {error || 'Error en el proceso de arribo'}
        </Typography>
      </Box>

      {shippingNumber && (
        <Typography
          variant='h6'
          sx={{ fontWeight: 700, color: 'white', opacity: 0.9, letterSpacing: '0.5px' }}
        >
          Pedido #{shippingNumber}
        </Typography>
      )}
    </Box>
  );
};

export default ErrorView;
